// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@mdi/font/css/materialdesignicons.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "pretty-checkbox/dist/pretty-checkbox.min.css";
import "./config/global.css";
import "mint-ui/lib/style.css";
import AlertPlugin from '@/components/alert/plugin';
// import and regist global plugin
import VueResource from "vue-resource";

import {MessageBox,Indicator,Toast } from "mint-ui";
Vue.prototype.$messagebox = MessageBox;
Vue.prototype.$Indicator = Indicator;
Vue.prototype.$Toast = Toast;


Vue.use(VueResource);

import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);

import PrettyCheckbox from "pretty-checkbox-vue";
Vue.use(PrettyCheckbox);

import Vuetify from "vuetify";
Vue.use(Vuetify, {
  iconfonts: ["mdi","fa"]
});

Vue.use(AlertPlugin)

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js